import axios from './axios-client';

export const getCities = async (setLoading = f => f, setData = f => f, setError = f => f) => {
  try {
    setLoading(true)
    const data = await axios.get(`city`);
    setData(data.data);
    setLoading(false);
  } catch (error) {
    setError(error)
    setLoading(false)
  }
};

export const searchCities = async (searchValue, setLoading = f => f, setData = f => f, setError = f => f) => {
  try {
    setLoading(true)
    const data = await axios.get(`city/search?searchText=${searchValue}`);
    setData(data.data);
    setLoading(false);
  } catch (error) {
    setError(error)
    setLoading(false)
  }
};
